import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { getDoctorTATAPI } from "../../../Api/MarketingApi";

interface DoctorTAT {
  DoctorId: number;
  StatusName: string | null;
  StartDate: string;
  EndDate: string | null;
  TimeTakenDays: number;
  SLA_AllowedDays: number | null;
  IsSLABreached: "YES" | "NO";
}

interface DoctorTATRowProps {
  doctorId: number;

}

const DoctorTATRow: React.FC<DoctorTATRowProps> = ({
  doctorId,

}) => {
  const [loading, setLoading] = useState(false);
  const [tatList, setTatList] = useState<DoctorTAT[]>([]);

  useEffect(() => {
    const fetchTAT = async () => {
      try {
        setLoading(true);
        const userId = Number(sessionStorage.getItem("userId"));
        const res = await getDoctorTATAPI(doctorId, `Viewed Doctor TAT of Doctor ID- ${doctorId}`, userId,"View Doctor TAT");
        setTatList(res.data );
      } catch (err) {
        console.error("TAT fetch failed", err);
      } finally {
        setLoading(false);
      }
    };

    fetchTAT();
  }, [doctorId]);
const formatDateTime = (date: string) => {
  return dayjs(date).format("DD MMM YYYY, hh:mm A");
};
  return (
  <tr className="bg-blue-10">
    <td  className="px-6 py-4">
      <div className="">
        {loading ? (
          <div className="flex justify-center py-6">
            <div className="animate-spin h-6 w-6 border-b-2 border-blue-600" />
          </div>
        ) : tatList.length === 0 ? (
          <div className="text-center text-sm text-gray-500 py-4">
            No TAT data available
          </div>
        ) : (
          <div className="rounded-xl border border-blue-500 bg-white p-4">
            <div className="flex gap-4 min-w-max">
              {tatList.map((tat, index) => (
                <div
                  key={index}
                  className={`min-w-[220px] rounded-xl px-4 py-3 shadow-sm border
                    ${
                      tat.IsSLABreached === "YES"
                        ? "bg-red-50 border-red-300"
                        : "bg-green-50 border-green-300"
                    }`}
                >
                  <p className="font-semibold text-sm text-gray-800">
                    {tat.StatusName || "N/A"}
                  </p>

                 <p className="text-xs text-gray-500 mt-1">
  Start: {formatDateTime(tat.StartDate)}
</p>

                 {tat.EndDate && (
  <p className="text-xs text-gray-500">
    End: {formatDateTime(tat.EndDate)}
  </p>
)}

                  <div className="mt-2 flex items-center justify-between">
                    <span className="text-xs font-medium">
                      Taken: {tat.TimeTakenDays}d
                    </span>

                    <span
                      className={`text-xs px-2 py-0.5 rounded-full font-semibold
                        ${
                          tat.IsSLABreached === "YES"
                            ? "bg-red-200 text-red-800"
                            : "bg-green-200 text-green-800"
                        }`}
                    >
                      SLA {tat.IsSLABreached}
                    </span>
                  </div>

                  {tat.SLA_AllowedDays !== null && (
                    <p className="text-[11px] text-gray-500 mt-1">
                      Allowed: {tat.SLA_AllowedDays} days
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </td>
  </tr>
);

};

export default DoctorTATRow;
